/**
 * Locale-aware number and currency formatting using native Intl API.
 */
export function formatNumber(value, locale = 'en-US') {
    try {
        return new Intl.NumberFormat(locale).format(value);
    }
    catch {
        return String(value);
    }
}
export function formatCurrency(value, currency, locale = 'en-US') {
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
        }).format(value);
    }
    catch {
        return String(value);
    }
}
